<template>
    <SeoHead :seo="seo" />
    <main-layout>
        <BestPlayersSection
            :best-players="bestPlayers"
            :available-seasons="availableSeasons"
            :current-season-id="currentSeasonId"
            :positions="positions"
            title="Топ игроков"
            heading-tag="h1"
        />
    </main-layout>
</template>

<script setup>
import SeoHead from '@/Components/SeoHead.vue';
import MainLayout from '@/components/layout/MainLayout.vue';
import BestPlayersSection from '@/components/best-players/BestPlayersSection.vue';

defineProps({
    seo: {
        type: Object,
        default: null,
    },
    bestPlayers: {
        type: Object,
        default: () => ({
            attack: { top: null, list: [] },
            serve: { top: null, list: [] },
            block: { top: null, list: [] },
            reception: { top: null, list: [] },
        }),
    },
    availableSeasons: {
        type: Array,
        default: () => [],
    },
    currentSeasonId: {
        type: Number,
        default: null,
    },
    positions: {
        type: Array,
        default: () => [],
    },
});
</script>
